import { Card, Chip, Grid2, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IZoneSchedule } from "../../../../../Domain/Types/FloorPlan/ZoneSchedule";
import {
  AssignedRoomlayout,
  RemoteRoomlayout,
  RoomlayoutIds
} from "../../../../../Domain/Types/FloorPlan/RoomlayoutAssignment.type";
import ServiceRoomLayoutTable from "./RoomLayoutTable.component";

type Props = {
  zoneSchedule: IZoneSchedule;
  roomLayout: RemoteRoomlayout[];
  assignedRoomLayout: AssignedRoomlayout[];
  onChangeConfService: (id: number, service: { roomlayouts: RoomlayoutIds[] }) => void;
  onClose: () => void;
};

export const RoomLayoutDialogContent = ({
  zoneSchedule,
  roomLayout,
  assignedRoomLayout,
  onChangeConfService,
  onClose
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      sx={{ p: 2, width: "75vw", overflow: "auto", maxHeight: "80%", backgroundImage: "unset" }}
      data-testid={"roomlayout-assignment-card"}
    >
      <Stack direction={"column"} gap={2}>
        {/* header of dialog content */}
        <Grid2 container sx={{ display: "grid" }} data-testid="roomlayout-dialog-content-header">
          <Grid2 container sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
            <Typography sx={{ textAlign: "left", lineHeight: 2.5 }} variant={"h6"}>
              {t("RoomLayoutDialogContentTitle")}
            </Typography>
            <Chip label={zoneSchedule.inventory?.name ?? "Zone"} />
          </Grid2>
          <Typography sx={{ textAlign: "left", lineHeight: 2 }} variant={"subtitle2"}>
            {t("RoomLayoutDialogContentSubTitle")}
          </Typography>
        </Grid2>

        {/* parent element of display and select options */}
        <Grid2
          container
          data-testid="roomlayout-assignment-parentEl"
          alignSelf={"center"}
          sx={{ width: "100%", maxHeight: "80vh" }}
        >
          <ServiceRoomLayoutTable
            zoneSchedule={zoneSchedule}
            roomLayout={roomLayout}
            assignedRoomLayout={assignedRoomLayout}
            onClose={onClose}
            onChangeConfService={onChangeConfService}
          />
        </Grid2>
      </Stack>
    </Card>
  );
};
